<template>
  <AGTooltip :direction="tooltipDirection" :disabled="!tooltip" :tooltip-text="tooltip">
    <v-btn
      :id="id"
      v-bind="$attrs"
      class="ag-btn-icon"
      variant="text"
      icon
      :class="{ 'v-btn--active': active }"
      :data-size="size"
      :disabled="disabled"
      :loading="loading"
      :to="to"
      :type="submit ? 'submit' : 'button'"
      @click="onClick"
    >
      <v-badge dot :model-value="showBadge">
        <AGIcon :icon="icon" :size="iconSize" :color="iconColor" />
      </v-badge>
    </v-btn>
  </AGTooltip>
</template>

<script>
import AGIcon from '@/components/common/AGIcon.vue';
import AGTooltip from '@/components/common/AGTooltip.vue';
import { uniqueId } from 'lodash';

export default {
  emits: ['click'],
  components: {
    AGTooltip,
    AGIcon,
  },

  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default: uniqueId('ag_btn_icon_'),
    },

    tooltip: {
      type: String,
      default: '',
    },

    tooltipDirection: {
      type: String,
      default: 'top',
      validator: (val) => ['top', 'bottom', 'left', 'right'].includes(val),
    },

    icon: {
      type: String,
      default: '',
    },

    iconSize: {
      type: String,
      required: false,
    },

    iconColor: {
      type: String,
      required: undefined,
    },

    size: {
      type: String,
      default: 'xl',
      validator(value) {
        return ['xl', 'lg', 'md', 'sm'].includes(value);
      },
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    to: {
      type: [String, Object],
      default: undefined,
    },

    submit: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    active: {
      type: Boolean,
      default: false,
    },

    showBadge: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/btn.scss';
</style>
